import { Modal, Button } from "antd";
import clsx from "clsx";
import { env } from "@/shared/config";
import "./external-link-modal.scss";

interface ExternalLinkModalProps {
  isOpen: boolean;
  url: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ExternalLinkModal = ({
  isOpen,
  url,
  onConfirm,
  onCancel,
}: ExternalLinkModalProps) => {
  const isOldFrontend = url.startsWith(env.OLD_FRONTEND_URL);

  return (
    <Modal
      title={
        <div className="external-link-modal__title">
          <span>
            {isOldFrontend
              ? "Перейти в раздел исполнительной документации билдокс"
              : "Внешняя ссылка"}
          </span>
        </div>
      }
      open={isOpen}
      onCancel={onCancel}
      width={720}
      footer={
        <div className="external-link-modal__footer">
          <Button onClick={onCancel}>Отмена</Button>
          <Button type="primary" onClick={onConfirm}>
            Перейти
          </Button>
        </div>
      }
    >
      {isOldFrontend ? (
        <div className="external-link-modal__body">
          <p>
            Вы переходите в раздел исполнительной документации билдокс.
            <br />
            Раздел будет открыт в новом окне браузера.
          </p>
          <div className="external-link-modal__divider" />
        </div>
      ) : (
        <div
          className={clsx(
            "external-link-modal__body",
            "external-link-modal__body--external",
          )}
        >
          <p>Вы переходите по внешней ссылке:</p>
          <p className="external-link-modal__url">{url}</p>
          <p>Вы уверены, что хотите покинуть страницу?</p>
        </div>
      )}
    </Modal>
  );
};
